import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/board/request/' // (3) 게시글 보기

let swrData: any = getPersistData(KEY)

export function useBoardContent(postId) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + postId,
		async () => {
			const response = await API.get(KEY + postId, token + '', {})
			swrData = response.result?.result

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		boardContent: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}